import api from 'src/utils/api';
import { E_API_SERVICEID } from 'src/utils/enum';

/**
 * @name 전단 목록 조회
 * @param str_cd 점포코드
 */
export const apiGetLeafletList = async params => {
  const response = await api.post(
    '/fo/product/leaflet/plate/select',
    { ...params },
    {
      headers: {
        'x-ssp-gateway-service-id': E_API_SERVICEID.PRODUCT,
      },
    },
  );
  const data = await response.data;

  return data;
};

/**
 * @name 전단 상세 조회
 * @param plate_leaflet_id 전단ID
 */
export const apiGetLeafletDetail = async params => {
  const response = await api.post(
    '/fo/product/leaflet/plate/show',
    { ...params },
    {
      headers: {
        'x-ssp-gateway-service-id': E_API_SERVICEID.PRODUCT,
      },
    },
  );
  const data = await response.data;

  return data;
};

/**
 * @name 전단 메뉴 목록 조회
 */
export const apiGetLeafletMenu = async () => {
  const response = await api.post(
    '/fo/product/leaflet/menu/select',
    {},
    {
      headers: {
        'x-ssp-gateway-service-id': E_API_SERVICEID.PRODUCT,
      },
    },
  );
  const data = await response.data;

  return data;
};

/**
 * @name 전단 허브 기초정보 조회
 */
export const apiGetHubInit = async () => {
  const response = await api.post(
    '/fo/product/leaflet/plate/init',
    {},
    {
      headers: {
        'x-ssp-gateway-service-id': E_API_SERVICEID.PRODUCT,
      },
    },
  );
  const data = await response.data;

  return data;
};
